import { Chat } from "@/components/Chat"
import { chatEvents } from "@/constants"
import { useEffect, useState } from "react"

export function App() {
  const [isOpen, setIsOpen] = useState(false)

  const toggleChat = () => {
    setIsOpen(!isOpen)
    window.postMessage({ type: isOpen ? chatEvents.CLOSE_CHAT : chatEvents.OPEN_CHAT }, "*")
  }

  useEffect(() => {
    function handler(event: MessageEvent) {
      if (event.data?.type === chatEvents.CHAT_CLOSED) setIsOpen(false)
    }

    window.addEventListener("message", handler)

    return () => {
      window.removeEventListener("message", handler)
    }
  }, [])

  return (
    <>
      <button onClick={toggleChat} className="fixed bottom-4 left-4 bg-gray-800 text-white px-3 py-2 rounded shadow hover:bg-gray-700 transition">
        Toggle Chat
      </button>

      <Chat />
    </>
  )
}
